// extracted by mini-css-extract-plugin
export default {"wrapper":"SalesLoginPage_wrapper__h7JV1","loginContainer":"SalesLoginPage_loginContainer__W7VIv","animationRoll":"SalesLoginPage_animationRoll__Nt3kq"};